
(function(){
  const RESULTS_URL              = '/pages/quiz-results';
  const FIND_PRO_URL             = '/pages/find-a-professional-quiz';
  const FIND_PRO_OPTION_SELECTOR = '[data-option-id="PdsqNiKrcPvxoYTK"]'; // <- your option
  const QUIZ_ID                  = 'yYRaXdbCk6IyHdH4';
  const OCTANE_SRC               = 'https://app.octaneai.com/l744vzic0hpd7ba6/quiz.js';
  const STORAGE_KEY_BLOCKS       = 'octane:product_blocks';
  const STORAGE_KEY_HANDLES      = 'octane:handles';

  let octaneScriptLoaded = false;
  let redirected = false;
  let pendingFindPro = false;     // set when user chooses Find-a-Professional
  let submitAttempted = false;

  /* ------------ storage helpers ------------ */
  function saveKV(k, v){
    const str = typeof v === 'string' ? v : JSON.stringify(v);
    try { sessionStorage.setItem(k, str); } catch(_){}
    try {   localStorage.setItem(k, str); } catch(_){}
  }
  function handlesFromBlocks(blocks){
    const out = new Set();
    (blocks || []).flat().forEach(p => {
      if (!p) return;
      if (p.handle) out.add(String(p.handle).trim());
      const m = (p.link || p.url || '').match(/\/products\/([^/?#]+)/);
      if (m) out.add(m[1]);
    });
    return [...out];
  }
  function handlesFromSections(sections){
    const out = new Set();
    (sections || []).forEach(sec =>
      (sec.products || []).forEach(p => {
        if (p?.handle) out.add(String(p.handle).trim());
        const m = (p?.link || '').match(/\/products\/([^/?#]+)/);
        if (m) out.add(m[1]);
      })
    );
    return [...out];
  }

  /* ------------ redirection ------------ */
  function go(url){
    if (redirected) return;
    redirected = true;
    window.location.assign(url);
  }
  function redirectToResults(handles){
    const short = (handles || []).slice(0, 12);
    if (short.length) saveKV(STORAGE_KEY_HANDLES, short.join(','));
    const qs = short.length ? ('?handles=' + encodeURIComponent(short.join(','))) : '';
    go(RESULTS_URL + qs);
  }

  /* ------------ try to trigger Octane’s final submit safely ------------ */
  function textMatches(btn){
    const t = (btn.innerText || btn.textContent || '').trim().toLowerCase();
    return /(results|finish|done|complete|submit)/.test(t); // CHANGED: stricter, removed "see|view"
  }
  function findSubmitButtons(){
    const root = document.getElementById('quiz-wrapper') || document;
    const candidates = [
      'button[type="submit"]',
      'button[data-testid*="submit"]',
      'button[data-testid*="finish"]',
      'button[data-testid*="results"]',
      '.oct-button--primary',
      'a[role="button"]',
      'button'
    ].flatMap(sel => Array.from(root.querySelectorAll(sel)));

    const enabled = candidates.filter(b => !b.disabled && b.offsetParent !== null);
    const strong  = enabled.filter(textMatches);
    return strong; // CHANGED: no fallback to any enabled button
  }
  function trySubmitQuiz(retries = 25){
    if (submitAttempted) return;
    submitAttempted = true;
    (function tick(i){
      const btns = findSubmitButtons();
      if (btns.length) { btns[0].click(); return; }
      if (i <= 0) return; // give up silently; we’ll still wait for event
      setTimeout(() => tick(i - 1), 160); // tiny bump
    })(retries);
  }

  /* ------------ hook the Find-a-Pro option (NO immediate redirect) ------------ */
  function markFindProAndSubmit(){
    pendingFindPro = true;
    // Wait a hair longer so Octane has recorded the choice & updated UI
    setTimeout(trySubmitQuiz, 300); // CHANGED: use longer delay
  }

  // CHANGED: listen to 'click' (bubble), not 'mousedown' (capture)
  document.addEventListener('click', (e) => {
    if (e.target.closest(FIND_PRO_OPTION_SELECTOR)) markFindProAndSubmit();
  }, false);

  // Optional: remove keydown handler to avoid double-trigger; click will fire for keyboard activation too.

  /* ------------ when Octane finishes, store → branch redirect ------------ */
  document.addEventListener('octane.quiz.completed', function (event) {
    const detail   = (event && event.detail) || {};
    const blocks   = detail.product_blocks || [];
    const sections = detail.sections || [];
    let handles    = handlesFromBlocks(blocks);
    if (!handles.length) handles = handlesFromSections(sections);

    saveKV(STORAGE_KEY_BLOCKS, blocks);
    if (handles.length) saveKV(STORAGE_KEY_HANDLES, handles.join(','));

    if (pendingFindPro) {
      go(FIND_PRO_URL);           // user chose Find-a-Professional
    } else {
      redirectToResults(handles); // normal flow
    }
  }, false);

  /* ------------ load Octane on demand ------------ */
  function loadOctaneScriptOnce(){
    if (octaneScriptLoaded) return;
    const s = document.createElement('script');
    s.src = OCTANE_SRC;
    s.defer = true;
    s.onload = () => { octaneScriptLoaded = true; };
    document.body.appendChild(s);
  }
  window.loadOctaneQuiz = function(){
    const landing = document.getElementById('quiz-landing');
    const wrapper = document.getElementById('quiz-wrapper');

    if (landing){ landing.classList.add('opacity-0'); setTimeout(() => landing.classList.add('hidden'), 400); }
    if (wrapper && !wrapper.querySelector('.octane-ai-quiz')) {
      wrapper.innerHTML = `
        <div class="octane-ai-quiz"
             data-quiz-id="${QUIZ_ID}"
             data-embed-type="fullpage"
             data-mobile-height="match_browser"
             data-desktop-height="match_browser"></div>`;
    }
    if (wrapper){ wrapper.classList.remove('hidden'); requestAnimationFrame(() => wrapper.classList.add('opacity-100')); }

    loadOctaneScriptOnce();
  };

  // Optional safety (keep commented unless you want a hard fallback):
  // setTimeout(() => { if (pendingFindPro && !redirected) go(FIND_PRO_URL); }, 10000);
})();

